
// Vue
import {Options, Vue} from "vue-class-component";

@Options({})
export default class PlayerResourcesNavigationVue extends Vue {}
